import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom';
import { CalendarToday, Check, LocationOn, Timelapse } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import TabsReservation from './TabsReservation';
import { userState } from 'src/store/user/userState';
import { grey } from '@mui/material/colors';
import { useTheme } from '@emotion/react';
import { capitalizeWord, serializeDateFormatLong, nameSede } from 'src/shared/global/helpers';
import { errorsFormRegisterState, errorsReservationGuestState, errorsReservationUserState, valuesFormRegisterState, valuesFormReservationGuestState, valuesFormReservationUserState } from 'src/Patient/state/atoms';
import { useSaveReservation } from './hooks/useSaveReservation';
import ProfessionalName from 'src/Professional/ProfessionalName';
import ProfessionalSpecialities from 'src/Professional/ProfessionalSpecialities';
import ProfessionalPhoto from 'src/Professional/ProfessionalPhoto';
import { useEffect } from 'react';
import ModalTitleCustom from 'src/shared/components/modals/ModalTitle';
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';
import { getImage } from "src/shared/global/pcd-img";
import { existPatientState } from "src/SearchHours/state/atoms";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },

    ".contFechaLogeado": {
        display: "flex",
        justifyContent: "space-between",
        gap: "1rem",
        paddingTop: "1rem",
        paddingBottom: "1rem",
    },

    ".contFechaNoLogeado": {
        display: "flex",
        justifyContent: "space-between",
        gap: "1rem",
        paddingTop: "1rem",
        paddingBottom: "1rem",

    },

    '.prestador': {
        marginTop: "1rem",
        marginBottom: "1rem",
        display: "flex",
        alignItems: "center",
    },

    '.formularioAcceso': {
        margin: 0,
        height: "100%",
        width: "100%",
        alignItems: "center",
    },

    [theme.breakpoints.up("xs")]: {
        ".contFechaNoLogeado": {
            padding: "1rem 0",
        },
    },

    [theme.breakpoints.up("md")]: {

        ".contFechaNoLogeado": {
            paddingRight: "1rem",
        },

        ".usuarioLogeado": {
            padding: "1rem",
        },

        ".usuarioSinLogear": {
            padding: "1rem",
        },
    },
}));

export default function ModalReservation() {
    const resetErrorsFormGuest = useResetRecoilState(errorsReservationGuestState);
    const setValuesFormReservationGuest = useSetRecoilState(valuesFormReservationGuestState);
    const resetValuesFormGuest = ()=>{
        setValuesFormReservationGuest((prev)=>{
            return {
                ...prev,
                usuApePat: null,
                usuApeMat: null,
                usuNombres: null,
                usuFono: null,
                usuCelular: null,
                ageEmail: null,
                ageEmailConfirm: null,
                fechaNac: null,
                isaCodigo: null,
            }
        })
    }
    const resetErrorsFormUser = useResetRecoilState(errorsReservationUserState);
    const resetValuesFormUser = useResetRecoilState(valuesFormReservationUserState);
    const resetValuesFormUserRegister = useResetRecoilState(valuesFormRegisterState);
    const resetErrorsFormRegister = useResetRecoilState(errorsFormRegisterState)
    const user = useRecoilValue(userState);

    //const valuesFormRegisterPatient = useRecoilValue(valuesFormRegisterState)
    //const [user] = useRecoilState(userState);
    const [indicacionesTexto, setTextoIndicaciones] = useState('');
    const [ocultar, setOcultar] = useState(false);

    const checkForDevice = () => window.innerWidth < 640;
    const [isMobile, setIsMobile] = useState(checkForDevice());

    let {
        handleClickSaveReservation,
        loadingSaved,
        hourSelected,
        setHourSelected,
        showModal,
        setShowModal,
    } = useSaveReservation()
    
    const theme = useTheme();

    const handleClose = (ev, reason) => {

        if (reason && reason === "backdropClick") return;

        resetErrorsFormGuest();
        resetValuesFormGuest();
        resetErrorsFormUser();
        resetValuesFormUser();
        resetValuesFormUserRegister();
        setHourSelected(null)
        setShowModal(false);
        resetErrorsFormRegister();

        setOcultar(false);

    };

    useEffect(() => {
        return () => {
            resetErrorsFormGuest();
            resetValuesFormGuest();
            resetErrorsFormUser();
            resetValuesFormUser();
            resetValuesFormUserRegister();
            //setHourSelected(null)
            //setShowModal(false);
            resetErrorsFormRegister();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //VALIDAR MOBILE O WEB
    useEffect(() => {
        const handlePageResized = () => {
          setIsMobile(checkForDevice());
        };
    
        if (typeof window !== 'undefined') {
          window.addEventListener('resize', handlePageResized);
          window.addEventListener('orientationchange', handlePageResized);
          window.addEventListener('load', handlePageResized);
          window.addEventListener('reload', handlePageResized);
        }
    
        return () => {
          if (typeof window !== 'undefined') {
            window.removeEventListener('resize', handlePageResized);
            window.removeEventListener('orientationchange', handlePageResized);
            window.removeEventListener('load', handlePageResized);
            window.removeEventListener('reload', handlePageResized);
          }
        };
      }, []);

    const confirmar = () => {
        eventGA();
        handleClickSaveReservation();
        let texto = "";
        texto = hourSelected?.professional.indicacionesPaciente;
        texto = typeof texto === 'undefined' ? "" : texto;
        if (texto.length > 0) {
            if(isMobile == true) {
                setOcultar(true);
            }

          } else {
            if(isMobile == true) {
                setOcultar(false);
            }

          }

    }

    const eventGA = () => {
        let especialidad = hourSelected?.professional.especialidades; //filterSearchSelected.specialitySelected.value;
        especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
        let profesional = hourSelected?.professional.ptdNombre;
        profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
        let hora = hourSelected?.hourSelected.ageInicio; //filterSearchSelected.covenantSelected.value;
        hora = hora != "" ? `| Hora: ${hora}` : "";
        ReactGA.event({
            category: 'Confirmar',
            action: `Se confirma hora para ${especialidad} ${profesional} ${hora}`
          });
    }
    const Indicaciones = () => {
        let texto = "";
        let myArray = [];
        let titulo = "";
        let descripcion = "";
        let myArrayDescripcion = [];
    
        try {
          texto = hourSelected?.professional.indicacionesPaciente;
          texto = typeof texto === 'undefined' ? "" : texto;
          if (texto.length > 0) {
            myArray = texto.split(";");
            titulo = myArray[0];
            descripcion = myArray[1];
            myArrayDescripcion = descripcion.split(",");
          } else {
          }
    
        } catch (error) {
          return (<>
            <Grid item xs={12} md={12} mr={0}>
              <Typography style={{ fontWeight: "600", fontSize: 14, backgroundColor: "#fff9c4", color: "#f57f17", padding: "0.25rem 0.5rem", }}>
                Indicaciones
              </Typography>
              {/* <pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto' ,  }}>
              {texto}
              </pre> */}
              {/* {ocultar == false ? (<pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto' ,  }}>
              {texto}
              </pre>) : (<></>)} */}

              <pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto'   }}>
              {ocultar == false ? texto : ('')}
              </pre> 

            </Grid>
    
          </>)
        }
    
        if(titulo.length > 0){
          return (<>
            <Grid item xs={12} md={12} mr={2}>
              <Typography style={{ fontWeight: "600", fontSize: 14, backgroundColor: "#fff9c4", color: "#f57f17", padding: "0.25rem 0.5rem", }}>
                {titulo}
              </Typography>
              <Typography style={{ fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", }}>
                <List dense={true}>
                  {myArrayDescripcion.map((item, i) => <ListItemText key={i} disablePadding>
                    <ListItemText primary={`・ ${item}`} />
                  </ListItemText>)}
                </List>
              </Typography>
            </Grid>
              
          </>)
        }else{
          return(<></>)
        }
    
      }

      const Indicaciones2 = () => {
        let texto = "";
        let myArray = [];
        let titulo = "";
        let descripcion = "";
        let myArrayDescripcion = [];
    
        try {
          texto = hourSelected?.professional.indicacionesEspecificas;
          texto = typeof texto === 'undefined' ? "" : texto;
          if (texto.length > 0) {
            myArray = texto.split(";");
            titulo = myArray[0];
            descripcion = myArray[1];
            myArrayDescripcion = descripcion.split(",");
          } else {
          }
    
        } catch (error) {
          return (<>
            <Grid item xs={12} md={12} mr={0}>
              <Typography style={{ fontWeight: "600", fontSize: 14, backgroundColor: "#fff9c4", color: "#f57f17", padding: "0.25rem 0.5rem", }}>
                Indicaciones
              </Typography>
              {/* <pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto' ,  }}>
              {texto}
              </pre> */}
              {/* {ocultar == false ? (<pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto' ,  }}>
              {texto}
              </pre>) : (<></>)} */}

              <pre style={{ fontFamily: 'Montserrat', fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", overflow: 'auto'   }}>
              {ocultar == false ? texto : ('')}
              </pre> 

            </Grid>
    
          </>)
        }
    
        if(titulo.length > 0){
          return (<>
            <Grid item xs={12} md={12} mr={2}>
              <Typography style={{ fontWeight: "600", fontSize: 14, backgroundColor: "#fff9c4", color: "#f57f17", padding: "0.25rem 0.5rem", }}>
                {titulo}
              </Typography>
              <Typography style={{ fontSize: 12, backgroundColor: "#F9FAFB", padding: "0.25rem 0.5rem", }}>
                <List dense={true}>
                  {myArrayDescripcion.map((item, i) => <ListItemText key={i} disablePadding>
                    <ListItemText primary={`・ ${item}`} />
                  </ListItemText>)}
                </List>
              </Typography>
            </Grid>
              
          </>)
        }else{
          return(<></>)
        }
    
      }
    return (
        <div className='animate__animated animate__fadeIn'>
            <BootstrapDialog
                fullWidth
                maxWidth={user.isAuthenticated ? "xs" : "lg"}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={showModal}
            >
                <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
                    Confirmar hora
                </ModalTitleCustom>

                <DialogContent>
                    <Grid container>
                        <Grid container item xs={12} md={user.isAuthenticated ? 12 : 5} style={{ height: "fit-content" }}>
                            <Grid className='prestador'>
                                <Grid width={64}>
                                    <ProfessionalPhoto
                                        width={64}
                                        height={100}
                                        image={getImage(hourSelected?.professional.aseDescrip, hourSelected?.professional.imagen)}
                                        alt={hourSelected?.professional.ptdNombre}
                                    />
                                </Grid>

                                <Grid ml={1}>
                                    <ProfessionalName fontSize={20} nameProfessional={hourSelected?.professional.ptdNombre} />
                                    <ProfessionalSpecialities specialities={hourSelected?.professional.especialidades} />
                                </Grid>
                            </Grid>
                            <Indicaciones key={1} data={indicacionesTexto}  />
                            <Indicaciones2 key={2} data={indicacionesTexto}  />
                            <Grid container className={user.isAuthenticated ? "contFechaLogeado" : "contFechaNoLogeado"} borderBottom={`1px solid ${theme.palette.default.main}`}>
                                <Grid item className='fechaConfirmada'>
                                    <Typography display={"flex"} alignItems={"center"} fontWeight={500}>
                                        <CalendarToday style={{ color: grey[300], marginRight: 5 }} />
                                        {capitalizeWord(serializeDateFormatLong(hourSelected?.hourSelected.ageFecha, true))}
                                    </Typography>
                                </Grid>

                                <Grid item className='horaConfirmada'>
                                    <Typography display={"flex"} alignItems={"center"} fontWeight={500}>
                                        <Timelapse style={{ color: grey[300], marginRight: 5 }} />
                                        {hourSelected?.hourSelected.ageInicio}
                                    </Typography>
                                </Grid>

                                <Grid item className='sedeConfirmada' alignContent={"center"}>
                                    <Typography display={"flex"} alignItems={"center"} fontWeight={500}
                                        color={theme.palette.secondary.main}
                                    >
                                        <LocationOn style={{ color: grey[300], marginRight: 5, }} />
                                        {hourSelected?.professional.sede} 
                                        {/* {nameSede(process.env.REACT_APP_SEDE)} */}
                                        {/* Clínica Andes Salud {process.env.REACT_APP_SEDE} */}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        {
                            !user.isAuthenticated ? (
                                <Grid item xs={12} md={7} >
                                    <Grid item className='formularioAcceso' style={{ border: `2px solid ${theme.palette.default.main}` }}>
                                        <TabsReservation />
                                    </Grid>
                                </Grid>
                            ) : null
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonCustom
                        loading={loadingSaved}
                        color="secondary"
                        onClick={confirmar}
                        text="CONFIRMAR RESERVA"
                        icon={<Check />}
                    />
                </DialogActions>
            </BootstrapDialog>
        </div >
    );
}